import { ConversationChannelTypeExtended } from '@provision/chat-utils';
import { ConversationParticipation, EntityIdentifier } from '@provision/entity-types';
import React from 'react';
import { Partner, UserGroupRules } from 'src/graphql';
import { UserPresence } from 'src/graphql/entities/user-presence/user-presence';
import { UseSelectedParticipants } from 'src/pages/Conversations/Chat/ParticipationPanel/use-selected-participants';
import { createContext, useContextSelector } from 'use-context-selector';
import { ProgrammaticScrollGuard } from './use-programmatic-scroll-guard';
import { ThreadGestureClock } from './use-thread-gesture-clock';

export interface ChatCommonData {
  conversationId: string;
  /** Absolute link to the conversation; empty until the partner's friendly id resolves. */
  conversationUrl: string;
  partnerId: string;
  hasAssociatedAddresses: boolean;
  partners: Record<string, Partner>;
  userPresenceMap: Map<string, UserPresence>;
  conversationParticipations: ConversationParticipation[];
  selectedParticipantsState: UseSelectedParticipants;
  channel: ConversationChannelTypeExtended | null;
  isChatReadOnly: boolean;
  reactionsEnabled: boolean;
  repliesEnabled: boolean;
  groupRules: Record<UserGroupRules, boolean>;
  chatRef: React.RefObject<HTMLDivElement | null>;
  gestureClock: ThreadGestureClock;
  scrollGuard: ProgrammaticScrollGuard;
  /** Resolves whether the reply was sent. */
  submitReply: (reply: ReplySubmission) => Promise<boolean>;
}

export interface ReplySubmission {
  parentConversationMessageId: string;
  body: string;
  mentions?: EntityIdentifier[];
}

export const ChatCommonDataContext = createContext<ChatCommonData>(null!);

export function useChatCommonData<T>(selector: (s: ChatCommonData) => T): T {
  return useContextSelector(ChatCommonDataContext, selector);
}
